import Button from "atoms/buttons/button";
import SupportUserSubscriptionRecord from "models/view-models/support-user-subscription-record";
import { ConfirmationModal } from "molecules/modals/confirmation-modal";
import SupportUserTeamManagementModal from "organisms/modals/support-user-team-manage-modal/support-user-team-manage-modal";
import React from "react";
import useCurrentIdentity from "utilities/hooks/use-current-identity";
import useModalActions from "utilities/hooks/use-modal-actions";
import GroupService from "utilities/services/groups/group-service";
import { ToastManager } from "utilities/toast/toast-manager";

interface SupportUserTeamManagementProps {
    subscription: SupportUserSubscriptionRecord;
    onRefresh?: () => Promise<void>;
}
const SupportUserTeamManagement = ({
    subscription,
    onRefresh = async () => {},
}: SupportUserTeamManagementProps) => {
    const { handleToggle, isOpen } = useModalActions();
    const { currentIdentity } = useCurrentIdentity();
    const {
        handleToggle: handleToggleResetConfirmation,
        isOpen: isResetConfirmationOpen,
    } = useModalActions();

    const handleResetTeam = async () => {
        const resetResponse = await GroupService.reset(subscription.groupId!);
        if (resetResponse.result?.hasErrors()) {
            ToastManager.error("Issue resetting team");
        } else {
            await onRefresh();
            handleToggleResetConfirmation();
        }
    };

    return (
        <>
            {subscription.isTeamOrEnterprise() && (
                <>
                    <Button onClick={handleToggle}>Migrate a Team</Button>

                    {currentIdentity?.isAdmin() && (
                        <Button onClick={handleToggleResetConfirmation}>
                            Reset a Team
                        </Button>
                    )}
                </>
            )}

            <SupportUserTeamManagementModal
                handleToggle={handleToggle}
                isOpen={isOpen}
                subscription={subscription}
                onRefresh={onRefresh}
            />
            <ConfirmationModal
                isVisible={isResetConfirmationOpen}
                message={
                    "Are you sure you want to RESET this team? This is a destructive action designed to assist in reusing test accounts and should not be used on customer accounts."
                }
                onCancel={handleToggleResetConfirmation}
                onConfirm={handleResetTeam}
            />
        </>
    );
};

export default SupportUserTeamManagement;
